import { render, staticRenderFns } from "./productRecommendation.html?vue&type=template&id=036909cd&scoped=true&"
import script from "./productRecommendation.vue?vue&type=script&lang=js&"
export * from "./productRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./productRecommendation.vue?vue&type=style&index=0&id=036909cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036909cd",
  null
  
)

export default component.exports